<template src="./RenunciaTable.html"></template>

<script>
import {Pagination, Table, TableColumn, Tag, Tooltip} from 'element-ui';
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import moment from "moment";
import {TableMixin} from "@/mixins/TableMixin";
import {utils} from "@/utils";
import ToolbarSearch from "@/components/Shared/ToolbarSearch/ToolbarSearch";
import {ActividadCiudadanoEstadoMixin} from "@/mixins/actividadCiudadanoEstado";
import {requestRenunciaPPMixin} from "@/api/partidoPolitico/renunciaPPApi";

export default {
  name: "RenunciaTable",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination,
    [Tooltip.name]: Tooltip,
    [Tag.name]: Tag,
    ToolbarSearch
  },
  mixins: [
    ScreenSizeMixin,
    NotifyMixin,
    TableMixin,
    requestRenunciaPPMixin,
    ActividadCiudadanoEstadoMixin
  ],
  data() {
    return {
      listSelection: [],
      isSelect: false,
      filter: ['id', 'run', 'nombres', 'paterno', 'materno', 'region', 'comuna', 'domicilio', 'fechacompleta'],
    }
  },
  beforeMount() {
    const pagingQuery = {
      currentPage: this.pagination.currentPage,
      pageSize: this.pagination.pageSize
    }
    this.getList(pagingQuery, true);
  },
  methods: {
    getList(pagingQuery = {}, firstTime = false) {
      this.loading = true;
      pagingQuery['compress'] = false
      pagingQuery['fields'] = this.filter

      this.getListaRenuncia(pagingQuery)
        .then(response => {
          this.$log.debug('getListaRenuncia', response.data.statusCode)

          if (response.data.statusCode === 200) {
            this.pagination.total = response.data.totalItems
            const data = JSON.parse(response.data.datos)

            this.tableData = data.map(row => {
              row.fechacompleta = moment.utc(row.fechacompleta).local().format('DD-MM-YYYY HH:mm')
              row.run = utils.rutFilter(row.run)
              return row
            })
            this.$log.debug(this.tableData)

            this.errored = false;
            if (this.tableData.length === 0) {
              if (firstTime) {
                this.showError('No hay renuncias, puede presionar el botón refrescar si lo desea.')
              } else {
                this.showWarn('No hay renuncias con sus filtros, puede presionar el botón refrescar si lo desea.')
              }
            }
            this.$scrollTo('#renunciaTable')
          } else {
            this.errored = true
            this.showError('Ocurrió un error inesperado al cargar los datos')
          }
        }).catch(err => {
        this.$log.fatal('getListaRenuncia', err, err.response, err.request)
        this.errored = true
        this.showError('Ocurrió un error inesperado al cargar los datos')
      })
        .finally(() => {
          this.loading = false
        })
    },
    onView(id) {
      this.$log.debug('onView', id)
      this.$emit('on-view', id)
    },
    btnViewTitle(id) {
      return `Ver Renuncia n° ${id}`
    },
  },
  computed: {
    perPage() {
      if (this.parametro.params)
        return parseInt(this.parametro.params.paginacion)
      return 10
    },

  },
}
</script>
